export class Perimetre {
  constructor(
      public id?: number,
      public regionInseeReg?: string,
      public valide?: boolean,
  ) {
      this.valide = false;
  }
}
